import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: "root"
})
export class BookAppointmentService {
  private isDealershipFormValid = new BehaviorSubject<boolean>(false);
  dealershipForm$ = this.isDealershipFormValid.asObservable();

  private isVehicleInfoFormValid = new BehaviorSubject<boolean>(false);
  vehicleInfo$ = this.isVehicleInfoFormValid.asObservable();

  private isAppointmentFormValid = new BehaviorSubject<boolean>(false);
  appointmentForm$ = this.isAppointmentFormValid.asObservable();

  private isCustomerInfoFormValid = new BehaviorSubject<boolean>(false);
  customerInfo$ = this.isCustomerInfoFormValid.asObservable();

  constructor() {}

  updateDealershipFormStatus(status: boolean): void {
    this.isDealershipFormValid.next(status);
  }

  updateVehicleInfoStatus(status: boolean): void {
    this.isVehicleInfoFormValid.next(status);
  }

  updateAppointmentFormStatus(status: boolean): void {
    this.isAppointmentFormValid.next(status);
  }

  updateCustomerInfoFormStatus(status: boolean): void {
    this.isCustomerInfoFormValid.next(status);
  }
  
  getDealershipState(): boolean {
    return this.isDealershipFormValid.getValue();
  }

  getVehicleInfoState(): boolean {
    return this.isVehicleInfoFormValid.getValue();
  }

  getAppointmentState(): boolean {
    return this.isAppointmentFormValid.getValue();
  }

  getCustomerInfoState(): boolean {
    return this.isCustomerInfoFormValid.getValue();
  }
}
